import { useState } from 'react';
export function useDialogContext() {
    var _a = useState(undefined), dialogProps = _a[0], setDialogProps = _a[1];
    return { dialogProps: dialogProps, setDialogProps: setDialogProps };
}
